import Immutable from "immutable";
import * as AF from "src/types/formTemplate";

type StateInternal = {
  original: AF.V2.FormTemplate;
  draft: AF.V2.FormTemplate;
  validations: Validations;
  importErrors: ImportErrors;
  questionModes: QuestionModes;
  diff: AF.V2.FormTemplateSimpleDiff;
};

const EmptyDiff: AF.V2.FormTemplateSimpleDiff = {
  sections: {},
  questions: {},
  verifications: {},
};
type Validations = Immutable.Map<string, Immutable.List<string>>;
type ImportErrors = Immutable.Map<string, Immutable.List<string>>;
type QuestionModes = Immutable.Map<string, "Edit" | "View">;
export type State = Immutable.Record<StateInternal>;
export function NewState(state: {
  original: AF.V2.FormTemplate;
  draft: AF.V2.FormTemplate;
  importErrors?: ImportErrors;
  questionModes?: QuestionModes;
  diff?: AF.V2.FormTemplateSimpleDiff;
}): State {
  return Immutable.Record({
    ...state,
    validations: Immutable.Map<string, Immutable.List<string>>(),
    importErrors:
      state.importErrors ?? Immutable.Map<string, Immutable.List<string>>(),
    questionModes:
      state.questionModes ?? Immutable.Map<string, "Edit" | "View">(),
    diff: state.diff ?? EmptyDiff,
  })();
}

export function getFullQuestions(state: State): Immutable.List<AF.V2.Question> {
  return Immutable.List<AF.V2.Question>(); // TODO
}

export function hasQuestionsInEditMode(state: State): boolean {
  return state.get("questionModes").some((mode) => mode === "Edit");
}

export function getQuestionMode(
  state: State,
  questionId: string
): "Edit" | "View" {
  return state.get("questionModes").get(questionId, "View");
}
